import {isEnter} from '@/util/keyCode';

/**
 * 查询dialog公共代码
 */
export default {
  props: {
    title: {
      type: String,
      default: '查询列表'
    },
    handleQuickSelect: Function
  },
  methods: {
    handleKeyDown({$event, $grid, $table}) {
      if (!isEnter($event)) {
        return;
      }
      const tableInstance = $grid || $table;
      const cellAreas = tableInstance.getCellAreas();
      if (!Array.isArray(cellAreas) || cellAreas.length !== 1) {
        return;
      }
      const rows = cellAreas[0].rows;
      if (!Array.isArray(rows) || rows.length !== 1) {
        return;
      }
      this.handleQuickSelect && this.handleQuickSelect({$event, $grid, $table, row: rows[0]});
    }
  }
};
